import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const NewCmaPage = lazy(() => import('../../pages/new-cma'));

// ----------------------------------------------------------------------

export const newCmaRoutes: RouteObject[] = [
  {
    path: 'new-cma',
    element: CONFIG.auth.skip ? (
      <Suspense fallback={<LoadingScreen />}>
        <DashboardLayout>
          <NewCmaPage />
        </DashboardLayout>
      </Suspense>
    ) : (
      <AuthGuard>
        <Suspense fallback={<LoadingScreen />}>
          <DashboardLayout>
            <NewCmaPage />
          </DashboardLayout>
        </Suspense>
      </AuthGuard>
    ),
  },
];
